import React from 'react'
import ContactCard from '../components/Form/ContactCard'
import Container from '../components/Container'

const Employment = () => {
  return (
    <>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">التوظيف</h1>
      </div>
      <Container>
        <article className="max-w-screen-md mx-auto">
          <div className="mb-8 grid gap-y-2">
            <h2 className="font-semibold text-xl">الوظائف المتاحة</h2>
            <p>حاليًا لا توجد وظائف شاغرة. سيتم الإعلان عن أي فرص عمل متوفرة عبر موقعنا. إذا كنت مهتمًا، يرجى إرسال سيرتك الذاتية إلى البريد الإلكتروني الخاص بالجمعية.</p>
          </div>
          <div className="grid gap-y-2 md:gap-4">
            <div className="grid gap-2 md:flex md:items-center md:gap-x-4">
              <ContactCard 
                icon={<svg xmlns="http://www.w3.org/2000/svg" width="2.63em" height="3em" viewBox="0 0 448 512">
                  <path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3z" />
                </svg>}
                title={'رقم الجوال'}
                type="mobile_number"
              />
              <ContactCard 
                icon={<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 20 20">
                  <path fill="#000" d="M3.87 4h13.25C18.37 4 19 4.59 19 5.79v8.42c0 1.19-.63 1.79-1.88 1.79H3.87c-1.25 0-1.88-.6-1.88-1.79V5.79c0-1.2.63-1.79 1.88-1.79m6.62 8.6l6.74-5.53c.24-.2.43-.66.13-1.07c-.29-.41-.82-.42-1.17-.17l-5.7 3.86L4.8 5.83c-.35-.25-.88-.24-1.17.17c-.3.41-.11.87.13 1.07z" />
                </svg>}
                title={'البريد الإلكتروني'}
                decription={'info@dareena.org'}
                type="email"
              />
            </div>
            <ContactCard 
              icon={<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 20 20">
                <path fill="#000" d="M11 1a8 8 0 1 1-1 15.938V12a3 3 0 0 0-3-3H3a8 8 0 0 1 8-8m-.5 3a.5.5 0 0 0-.5.5v5l.008.09a.5.5 0 0 0 .492.41h3l.09-.008A.5.5 0 0 0 13.5 9H11V4.5l-.008-.09A.5.5 0 0 0 10.5 4M1 12a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm5.5 0h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1m0 2h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1m0 2h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1" />
              </svg>}
              title={'أوقات العمل'}
              decription={'من الأحد إلى الخميس  - من الساعة الثامنة صباحاً وحتى الثالثة والنصف مساءً.'}
              type="text"
            />
            <ContactCard 
              icon={<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 24 24">
                <path fill="#000" d="M12 2C7.589 2 4 5.589 4 9.995C3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12c0-4.411-3.589-8-8-8m0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4" />
              </svg>}
              title={'العنوان'}
              decription={'محافظة القطيف – مركز دارين – جزيرة دارين'}
              type="address"
            />
          </div>
        </article>
      </Container>
    </>
  )
}

export default Employment